import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export class ErrorHandlerUtil {
  private static translate: TranslateService;

  static setTranslateService(translate: TranslateService) {
    ErrorHandlerUtil.translate = translate;
  }

  private static t(key: string): string {
    if (ErrorHandlerUtil.translate) {
      return ErrorHandlerUtil.translate.instant(key);
    }
    // Fallback English messages if translate not available
    const fallbacks: Record<string, string> = {
      'ERRORS.DEFAULT_LATER': 'Something went wrong. Please try again later.',
      'ERRORS.NO_CONNECTION': 'Unable to connect to the server. Please check your internet connection or try again later.',
      'ERRORS.NOT_FOUND': "We couldn't find the requested service. Please contact support.",
      'ERRORS.SERVER_ERROR': 'Oops! There was a problem on our side. Please try again later.',
      'ERRORS.UNAUTHORIZED': 'Your session has expired or you are not authorized.',
      'ERRORS.NO_INTERNET': 'No internet connection. Please check your network.',
      'ERRORS.UNEXPECTED': 'Unexpected error occurred'
    };
    return fallbacks[key] || key;
  }

  static extractError(err: any): string {
    // Case: no error object provided
    if (!err) return ErrorHandlerUtil.t('ERRORS.DEFAULT_LATER');

    // Case: error is already a string
    if (typeof err === 'string') return err;

    if (err.status === 0) {
      return ErrorHandlerUtil.t('ERRORS.NO_CONNECTION');
    }

    // Case: Angular HttpErrorResponse with status code
    if (err.status) {
      if (err.status === 404) return ErrorHandlerUtil.t('ERRORS.NOT_FOUND');
      if (err.status === 500) return ErrorHandlerUtil.t('ERRORS.SERVER_ERROR');
      if (err.status === 401) return ErrorHandlerUtil.t('ERRORS.UNAUTHORIZED');
    }

    // Case: HttpErrorResponse with error property
    if (err.error) {
      // If the backend returned plain text
      if (typeof err.error === 'string') {
        return err.error;
      }
      // If the backend returned a JSON with a "message" property
      if (err.error?.message) {
        return err.error.message;
      }
    }

   // Case: error object contains a message property
    if (err.message) return err.message;

  // Case: network issues or CORS errors (ProgressEvent)
    if (err instanceof ProgressEvent) {
      return ErrorHandlerUtil.t('ERRORS.NO_INTERNET');
    }

  // Default case: unknown structure
    return ErrorHandlerUtil.t('ERRORS.UNEXPECTED');
  }
}
